import { TLoggerMessage } from '../logger.types';

export async function sendToApi(level: 'debug' | 'info' | 'warn' | 'error', o: TLoggerMessage) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { msg, level: _inputLevel, time: _inputTime, ...inputPayload } = o;

  o.timestamp = new Date().toISOString();

  o.payload ||= {};
  o.payload = {
    ...inputPayload,
    ...o.payload,
  };

  o.payload.window ||= {
    location: {
      href: window.location.href,
      pathname: window.location.pathname,
    },
  };

  o.payload.navigator ||= {
    user_agent: window.navigator.userAgent,
  };

  // if ((window as { __debug?: boolean }).__debug) {
  console.groupCollapsed(`${level.toUpperCase()} | ${o.msg}`);
  console.log(
    JSON.stringify(
      {
        msg: o.msg,
        payload: o.payload,
        timestamp: o.timestamp,
      },
      null,
      4
    )
  );
  console.groupEnd();
  // }

  fetch('/api/v3/log', {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      log: {
        level: level.toUpperCase(),
        data: {
          message: o.msg,
          payload: o.payload,
        },
        timestamp: o.timestamp,
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        console.error(`Unable to send log message to API due to ${response.status}`);
      }
    })
    .catch((error) => {
      console.error('Unexpected error occured while sending log message to API', error);
    });
}
